class VendorSizeGuide extends HTMLElement{
connectedCallback(){this.addEventListener('click',this);
if(new URLSearchParams(location.search).has('size-guide'))this.open()}
handleEvent(e){const t=e.target;
if(t.closest('.cc-vsg__trigger'))this.open();
else if(t.closest('.cc-vsg__close-btn'))this.close();
else if(t.closest('.cc-vsg__overlay'))this.close();
else if(t.closest('.cc-vsg__accordion-trigger'))this.acc(t);
else if(t.closest('.cc-vsg__play-btn'))this.play(t)}
open(){this.q('.cc-vsg__overlay')?.classList.add('cc-vsg__overlay--open');
this.q('.cc-vsg__drawer')?.classList.add('cc-vsg__drawer--open');
const s=window.innerWidth-document.documentElement.clientWidth;
document.body.style.overflow='hidden';
document.body.style.paddingRight=s+'px';
document.body.classList.add('cc-vsg--open');
this._k=e=>{if(e.key==='Escape')this.close()};
document.addEventListener('keydown',this._k);
this.param(true);
this.q('.cc-vsg__close-btn')?.focus()}
close(){this.q('.cc-vsg__overlay')?.classList.remove('cc-vsg__overlay--open');
this.q('.cc-vsg__drawer')?.classList.remove('cc-vsg__drawer--open');
document.body.style.overflow='';
document.body.style.paddingRight='';
document.body.classList.remove('cc-vsg--open');
if(this._k)document.removeEventListener('keydown',this._k);
this.param(false);
this.q('.cc-vsg__trigger')?.focus()}
param(on){const u=new URL(location.href);
if(on)u.searchParams.set('size-guide','open');else u.searchParams.delete('size-guide');
history.replaceState(null,'',u)}
acc(t){const a=t.closest('.cc-vsg__accordion');
a?.classList.toggle('cc-vsg__accordion--open');
const b=a?.querySelector('.cc-vsg__accordion-trigger');
if(b)b.setAttribute('aria-expanded',a.classList.contains('cc-vsg__accordion--open'))}
play(t){const w=t.closest('.cc-vsg__measure-img');if(!w)return;
const u=w.dataset.embed;if(!u)return;
const f=document.createElement('iframe');
f.src=u;f.allowFullscreen=true;f.allow='autoplay';
f.style.cssText='position:absolute;inset:0;width:100%;height:100%;border:none';
w.style.position='relative';w.innerHTML='';w.appendChild(f)}
q(s){return this.querySelector(s)}}
customElements.define('vendor-size-guide',VendorSizeGuide);
